import './preload-skeleton.scss';

import React, { Component } from 'react';

export default class PreloadSkeleton extends Component {
  createSideBarItems() {
    let items = [];

    // 写定 20 条数据
    for (let i = 0; i < 20; i++) {
      items.push(
        <div className="o-bg-grey skeleton__sidebar--item" key={i}>
          <div className="skeleton__sidebar--item-inner"></div>
        </div>
      );
    }

    return items;
  }

  createListItems() {
    let items = [];

    for (let i = 0; i < 20; i++) {
      items.push(
        <div className="skeleton__list--item" key={i}>
          <div className="skeleton__list--img"></div>
          <div className="o-flex skeleton__list--desc">
            <div className="skeleton__list--desc-title"></div>
            <div className="skeleton__list--desc-detail"></div>
            <div className="o-flex skeleton__list--desc-operation">
              <div className="operation__desc"></div>
              <div className="operation__btn"></div>
            </div>
          </div>
        </div>
      );
    }

    return items;
  }

  render() {
    const sidebarItems = this.createSideBarItems();
    const listItems = this.createListItems();

    return (
      <div className="o-bg-white skeleton__container">
        <div className="skeleton__header">
          <div className="o-flex skeleton__shop">
            <div className="skeleton__header--avatar"></div>
            <div className="skeleton__header--title">
              <div className="skeleton__header--title-top"></div>
              <div className="skeleton__header--title-bottom"></div>
            </div>
          </div>
          <div className="skeleton__ads">
            <div className="skeleton__ads--item"></div>
          </div>
        </div>
        <div className="o-flex skeleton__body">
          <div className="skeleton__sidebar">
            {sidebarItems}
          </div>
          <div className="skeleton__list">
            <div className="skeleton__list--title"></div>
            {listItems}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/dish-menu/preload-skeleton.jsx